<template>
  <div class="result_wrap">
    <ul v-if="results.length > 0" class="search_list">
      <li v-for="(result, index) in results" :key="index" v-show="index < 2">
        <router-link
          :to="{
            name: `book_detail`,
            params: {
              id: result.bookCd || result.id,
              orderId: result.orderId
            }
          }"
          class="book_link"
          @click.native="disNonSearch"
        >
          <figure>
            <img :src="result.thumbUrl" :alt="result.bookNm" />
            <figcaption>
              <span class="book_name">{{ result.bookNm }}</span>
              <span class="book_author">{{ result.author }}</span>
            </figcaption>
          </figure>
        </router-link>
      </li>
      <li v-if="results.length > 1" class="more" @click="handleMoreClick">
        <span>더보기</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'SearchModal',
  props: {
    showSearchModal: {
      type: Boolean,
      required: true
    },
    searchQuery: {
      type: String,
      required: true
    },
    searchTp: {
      type: String,
      required: true
    },
    searching: {
      type: Boolean,
      required: true
    },
    results: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  mounted() {
    // this.preventVerticalScroll()
  },
  beforeDestroy() {
    window.removeEventListener('wheel', this.handleWheel)
  },
  methods: {
    disNonSearch() {
      this.$emit('close')
    },
    preventVerticalScroll() {
      window.addEventListener('wheel', this.handleWheel, { passive: false })
    },
    handleWheel(event) {
      if (event.deltaY !== 0) {
        event.preventDefault()
      }
    },
    handleMoreClick() {
      this.$router.push({
        name: 'search',
        query: {
          keyword: this.searchQuery,
          searchTp: this.searchTp
        }
      })
      this.disNonSearch()
    }
  }
}
</script>
<style lang="scss" scoped>
.search_wrap {
  li {
    margin-bottom: 10px;
    &.more {
      text-align: center;
      span {
        display: inline-block;
        padding: 12px 38px;
        border: 1px solid #727272;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 600;
        color: #231815;
        cursor: pointer;
      }
    }
    figure {
      display: flex;
      align-items: center;
      gap: 15px;
      img {
        width: 108px;
        height: 150px;
        border: 1px solid #727272;
      }
      figcaption {
        span {
          display: block;
          width: 145px;
          word-break: keep-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          &:first-child {
            margin-bottom: 12px;
            line-height: 21px;
            font-family: 'pretendard-medium';
            font-size: 18px;
          }
          &:last-child {
            font-size: 14px;
            line-height: 14px;
          }
        }
      }
    }
  }
}
@media (max-width: 480px) {
  .result_wrap {
    margin-top: 24px;
    .default_result span {
      font-size: 18px;
      &.result_ment {
        font-size: 18px;
        color: rgba(48, 48, 48, 0.5);
      }
      &.guide {
        display: block;
        margin-top: 52px;
        margin-bottom: 79px;
        text-align: center;
        color: rgb(151 151 151);
      }
    }
  }
  .search_list {
    padding-left: 15px;
    li {
      margin-bottom: 10px;
      &.more {
        text-align: center;
        span {
          display: inline-block;
          padding: 12px 38px;
          border: 1px solid #727272;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 600;
          color: #231815;
        }
      }
      figure {
        display: flex;
        align-items: center;
        gap: 15px;
        img {
          width: 103px;
          height: 140px;
          border: 1px solid #727272;
        }
        figcaption {
          span {
            display: block;
            width: 145px;
            word-break: keep-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            &:first-child {
              margin-bottom: 12px;
              line-height: 21px;
              font-family: 'pretendard-medium';
              font-size: 18px;
            }
            &:last-child {
              font-size: 14px;
              line-height: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
